import {BaseApi, Options} from "../BaseApi";

export class IntegrationsApi extends BaseApi {
    public getIntegrationsList(): Promise<any> {
        return this.get("/integration/list")
    }

    public getIntegrationById(options?: Options): Promise<any> {
        return this.get("integration/:id", options)
    }

    public createIntegration(options?: Options): Promise<any> {
        return this.post("/integration/create", options)
    }

    public updateIntegration(options?: Options): Promise<any> {
        return this.put("/integration/update", options)
    }


    public deleteIntegration(options?: Options): Promise<any> {
        return this.delete("/integration/delete", options)
    }


    //------- AUTH

    public startOAuth2 (options?: Options ): Promise<any> {
        return this.get("/auth/oauth2/start/:integrationId", options)
    }

    public getIntegrationAuth(options?: Options): Promise<any> {
        return this.get("/auth/:integrationId", options)
    }

    public getIntegrationAuthField(options?: Options): Promise<any> {
        return this.get("/auth/field/get/:fieldId", options)
    }


    public createIntegrationAuth(options?: Options): Promise<any> {
        return this.post("/auth/create", options)
    }

    public createIntegrationAuthFields(options?: Options): Promise<any> {
        return this.patch("/auth/:id/field/add", options)
    }


    public deleteAuthFields(options?: Options): Promise<any> {
        return this.delete("/auth/field/delete/:fieldId", options)
    }

    public configureTestRequest(options?: Options): Promise<any> {
        return this.patch("/auth/:id/configure/test-request", options)
    }

    public configureTokenExchangeRequest(options?: Options): Promise<any> {
        return this.patch("/auth/:id/configure/token-exchange-request", options)
    }

    public configureAuthorizationRequest(options?: Options): Promise<any> {
        return this.patch("/auth/:id/configure/authorization-request", options)
    }

    public configureAccessTokenRequest(options?: Options): Promise<any> {
        return this.patch("/auth/:id/configure/access-token-request", options)
    }

    public createConnection(options?: Options): Promise<any> {
        return this.post("/connection/create", options)
    }

    public getConnectionsList(options?: Options): Promise<any> {
        return this.get("/connection/list/:integrationId", options)
    }

    public testAuth(options?: Options): Promise<any> {
        return this.post("/auth/test", options)
    }

    public deleteAuth(options?: Options): Promise<any>  {
        return this.delete("/auth/delete/:authId", options)
    }


    //------ TRIGGER
    public IntegrationEventsAdd(url: string, data: any): Promise<any> {
        return this.post(url, {data: data})
    }

    public getIntegrationTriggersList(options?: Options): Promise<any> {
        return this.get("/trigger/list/:integrationId", options)
    }

    public getIntegrationTriggerById(options?: Options): Promise<any> {
        return this.get("/trigger/:id", options)
    }

    public getIntegrationActionById(options?: Options): Promise<any> {
        return this.get("/action/:id", options)
    }

    public IntegrationApiEndpointConfigure(url: string, data: any, params: any): Promise<any> {
        return this.patch(url, {data: data, params: params})
    }


    //------ ACTION


    public getIntegrationActionsList(options?: Options): Promise<any> {
        return this.get("/action/list/:integrationId", options)
    }

    //-------EVENTS

    public IntegrationEventTest(url: string, data: any): Promise<any> {
        return this.post(url, {data: data})
    }


    public IntegrationEventDelete(url: string): Promise<any> {
        return this.delete(url)
    }

}